import React, {ChangeEvent, useState} from "react";

import {Button, Input} from "@chakra-ui/react";

import {TeqTeamAssessmentGroupDto} from "./api/dtos";

import TeqTeamAssessmentGroupChart from "./teq-team-assessment-group-chart";

function AutomatedTeqTeamAssessmentGroupResult() {
    const [value, setValue] = useState<string>("");
    const [response, setResponse] = useState<TeqTeamAssessmentGroupDto | null>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    }

    const onSubmit = async () => {
        if (value) {
            const parsedResponse: TeqTeamAssessmentGroupDto = JSON.parse(value);

            setResponse(parsedResponse);
        }
    }

    if (!response) {
        return (
            <form>
                <Input value={value}
                       onChange={handleChange}
                       name="input"/>

                <Button name="submit" onClick={onSubmit} type="submit">Submit</Button>
            </form>
        );
    } else {
        return (
            <div id="diagnostic-results">
                <TeqTeamAssessmentGroupChart teq={response}/>
            </div>
        )
    }
}


export default AutomatedTeqTeamAssessmentGroupResult;
